import { useQuery } from 'react-query';
import { ApiError, EnumData } from 'src/modules/generated-api-clients/no-sql';
import { useApiNoSqlContext } from 'src/modules/contexts/ApiNoSqlContext';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { logApiError, logAxiosError, logError } from './helpers';
// import { logRequest } from './helpers';
import { QUERY_KEYS } from './enums';
import { AxiosError } from 'axios';

/**
 * Custom hook for fetching constants from the API.
 * Endpoint: GET '/api/v2/read/constants'
 * @returns An object containing the constants and error, if any.
 */
export const useQueryConstants = () => {
	const { client } = useApiNoSqlContext();
	const { user } = useAuthenticator(context => [context.user]);
	return useQuery<EnumData, ApiError>([QUERY_KEYS.constants.SingleConstantsObject, user], async () => {
		try {
			if (!client) {
				throw new Error('API client is not initialized');
			}
			if (user.attributes === undefined) {
				throw new Error('AWS Amplify user attributes cannot be undefined');
			}
			const response = await client.frontentConstantVariables.constantVariablesApiV2ReadConstantsGet();
			// logRequest({}, 'GET', QUERY_KEYS.constants.SingleConstantsObject, response);
			return response;
		} catch (error: unknown) {
			if (error instanceof ApiError) {
				logApiError(error);
			} else if (error instanceof AxiosError) {
				logAxiosError(error);
			} else {
				logError(error, 'Error fetching constants');
			}
			throw error;
		}
	});
};
